import { render, staticRenderFns } from "./town-select.vue?vue&type=template&id=20b92992&scoped=true"
import script from "./town-select.vue?vue&type=script&lang=js"
export * from "./town-select.vue?vue&type=script&lang=js"
import style0 from "./town-select.vue?vue&type=style&index=0&id=20b92992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b92992",
  null
  
)

export default component.exports